// Test IDs for the MANU VET landing page.
// Naming: keys camelCase, values kebab-case `<feature>-<element>`.

export const LANDING = {
    // Header / nav
    header: 'landing-header',
    headerLogo: 'landing-header-logo',
    navHome: 'landing-nav-home',
    navProducts: 'landing-nav-products',
    navBrands: 'landing-nav-brands',
    navServices: 'landing-nav-services',
    navClients: 'landing-nav-clients',
    navContact: 'landing-nav-contact',
    headerCallBtn: 'landing-header-call-btn',
    headerVisitBtn: 'landing-header-visit-btn',
    mobileMenuToggle: 'landing-mobile-menu-toggle',
    mobileMenu: 'landing-mobile-menu',

    // Hero
    hero: 'landing-hero',
    heroTitle: 'landing-hero-title',
    heroCallBtn: 'landing-hero-call-btn',
    heroDirectionsBtn: 'landing-hero-directions-btn',

    // Sections
    categories: 'landing-categories',
    categoryCard: 'landing-category-card',
    brands: 'landing-brands',
    brandCard: 'landing-brand-card',
    services: 'landing-services',
    reassurance: 'landing-reassurance',
    clients: 'landing-clients',
    sectors: 'landing-sectors',
    sectorChip: 'landing-sector-chip',
    testimonials: 'landing-testimonials',

    // Contact
    contact: 'landing-contact',
    contactForm: 'landing-contact-form',
    contactName: 'landing-contact-name',
    contactCompany: 'landing-contact-company',
    contactPhone: 'landing-contact-phone',
    contactEmail: 'landing-contact-email',
    contactMessage: 'landing-contact-message',
    contactInterest: 'landing-contact-interest',
    contactSubmit: 'landing-contact-submit',
    contactMap: 'landing-contact-map',

    // Footer
    footer: 'landing-footer',

    // Mobile sticky CTA
    mobileCallBtn: 'landing-mobile-call-btn',
    mobileDirectionsBtn: 'landing-mobile-directions-btn',
};
